// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InfoOutlinedSvg from "@fishx/icons-svg/es/asn/InfoOutlined";
import FishxIcon from '../components/FishxIcon';

var InfoOutlined = function InfoOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: InfoOutlinedSvg
  }));
};

InfoOutlined.displayName = 'InfoOutlined';
export default React.forwardRef(InfoOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/InfoOutlined.js
// module id = 2976
// module chunks = 0